import { render, staticRenderFns } from "./PaletteChip.vue?vue&type=template&id=5862f598&scoped=true&"
import script from "./PaletteChip.vue?vue&type=script&lang=js&"
export * from "./PaletteChip.vue?vue&type=script&lang=js&"
import style0 from "./PaletteChip.vue?vue&type=style&index=0&id=5862f598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862f598",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCol,VIcon,VRow,VSlider,VTooltip})
